import { render, staticRenderFns } from "./ClassStudentsModal.vue?vue&type=template&id=cb4076a4&scoped=true"
import script from "./ClassStudentsModal.vue?vue&type=script&lang=js"
export * from "./ClassStudentsModal.vue?vue&type=script&lang=js"
import style0 from "./ClassStudentsModal.vue?vue&type=style&index=0&id=cb4076a4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cb4076a4",
  null
  
)

export default component.exports